<template>
  <div>
    <input v-model=login type="text">
    <input v-model=password type="password">
    <button @click=adminLogin>Увійти</button>
  </div>
</template>

<script>
  export default {
    name: "Login",

    data: function () {
      return {
        login: null,
        password: null,
      }
    },

    methods: {
      async adminLogin(){
          try{
          const response = await this.$store.dispatch('login', {login: this.login, password: this.password})
          if (!response)
            {
              this.$notify(
              {
                group: 'foo',
                type: 'success',
                title: 'Вітаю',
                text: "Ви успішно залогінились",
              });
              this.$router.push('/admin/menu')
            }
            else{
                this.$notify(
              {
                group: 'foo',
                type: 'error',
                title: 'Помилка, зверніться до адміністратора',
                text: `${response.humanText}`,
              });
            }
          }
          catch(error){
              this.$notify(
              {
                group: 'foo',
                type: 'error',
                title: 'Помилка, зверніться до адміністратора',
                text: `${error}`,
              });
          }
      }
    },

    computed: {
    },
  }
</script>

<style scoped>
  .modal-login__logo {
    margin-bottom: 30px;
  }

  .modal-login__form {
    margin: 0 auto;
    max-width: 300px;
  }
</style>